import SelectionItem from './SelectionItem.component';

export default SelectionItem;